import Header from "./Components/Header";
import Expense from "./Components/Expense";
import app from "./app.css";

function App() {
  return (
    <div className="App">
        <Header />
        <Expense />
    </div>
  );
}

export default App;
